import React from "react"
import ChatWindow from "../ChatComponent/ChatComponent"
import chatIcon from "../../assets/images/chat-icon-new.svg"
import OutsideAlerter from "./outsideClickHandler"
import "./ChatPopup.scss"
import { useRef } from "react"
import {
  FirebaseService,
  FirebaseContext,
  FIREBASE_STATE_KEYS,
} from "../../firebase"
import _ from "lodash"
import { emitter } from "../../utils/emitter"
import { CUSTOM_EVENTS } from "../../constants/commons"

export const ChatPopup = props => {
  const [visible, setVisible] = React.useState(false)
  const [showUnreadIndicator, setShowUnreadIndicator] = React.useState(false)
  const { userState } = React.useContext(FirebaseContext)
  const toggleUnreadIndicator = visibility => setShowUnreadIndicator(visibility)
  const toggleVisibility = () => setVisible(visible => !visible)
  const toggleVisibilitytoFalse = () => setVisible(false)
  // Disabled Chat if the partner has not accepted the invite.
  const isChatDisabled = props.partner == null ? true : false

  // save last read message timestamp / last seen for the user.
  React.useEffect(() => {
    if (!visible) {
      const userId = _.get(userState, "userDetails.uuid", "")
      const path = `${FirebaseService.getDefaultPath()}${userId}`
      if (userId) {
        FirebaseService.patch(
          { [FIREBASE_STATE_KEYS.LAST_SEEN_MESSAGES_AT]: Date.now() },
          path
        )
      }
    }
  }, [visible])

  React.useEffect(() => {
    const listeners = [
      emitter.addListener(CUSTOM_EVENTS.OPEN_CHAT_POPUP, () => {
        setVisible(true)
      }),
      emitter.addListener(CUSTOM_EVENTS.CLOSE_CHAT_POPUP, () => {
        setVisible(false)
      }),
      emitter.addListener(CUSTOM_EVENTS.CHAT_SHOW_UNREAD_DOT, () => {
        setShowUnreadIndicator(true)
      }),
      emitter.addListener(CUSTOM_EVENTS.CHAT_HIDE_UNREAD_DOT, () => {
        setShowUnreadIndicator(false)
      }),
    ]
    return function emitterCleanUp() {
      listeners.forEach(ele => ele.remove())
    }
  }, [])

  const chatRef = useRef()

  return (
    <section
      className="chat-popup-container"
      id="chat-popup-container"
      ref={chatRef}
    >
      {props.children}
      <button
        className="chat-btn"
        onClick={toggleVisibility}
        disabled={isChatDisabled}
      >
        {showUnreadIndicator && <span className="unread-indicator"></span>}
        <img src={chatIcon} alt="chat-icon" className="chat-icon" />
      </button>
      <OutsideAlerter toggleVisibilitytoFalse={toggleVisibilitytoFalse}>
        <section className="chat-window-container">
          <ChatWindow
            onClose={toggleVisibility}
            visible={visible}
            toggleUnreadIndicator={toggleUnreadIndicator}
            openChat={() => {
              if (!visible) setVisible(true)
            }}
            chatRef={chatRef}
          />
        </section>
      </OutsideAlerter>
    </section>
  )
}
